/*
  Blog slider: horizontal scroll-snap slider för bilder/produkter i blog-poster.

  Tag baseras på CSS-klass (.blog-slider) eftersom Shopifys rich-text-editor
  ev. strippar custom elements. JS letar upp alla .blog-slider, wrappar deras
  barn i en track-div och lägger till pil-knappar för desktop.

  Förväntad input-HTML (vad Anki klistrar in):
    <div class="blog-slider">
      <a class="blog-slide" href="/products/x">
        <img src="..." alt="...">
        <span class="blog-slide__caption">Titel</span>
        <span class="blog-slide__meta">Från 1 200 kr</span>
      </a>
      ... fler .blog-slide ...
    </div>
*/

(function () {
  function initSlider(slider) {
    if (slider.dataset.initialized) return;
    slider.dataset.initialized = 'true';

    const slides = Array.from(slider.children).filter((c) =>
      c.classList.contains('blog-slide')
    );
    if (slides.length === 0) return;

    const track = document.createElement('div');
    track.className = 'blog-slider__track';
    slides.forEach((slide) => track.appendChild(slide));

    slider.innerHTML = '';
    slider.appendChild(track);

    addArrows(slider, track);
  }

  function addArrows(slider, track) {
    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'blog-slider__arrow blog-slider__arrow--prev';
    prev.setAttribute('aria-label', 'Föregående');
    prev.innerHTML = arrowSvg('left');

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'blog-slider__arrow blog-slider__arrow--next';
    next.setAttribute('aria-label', 'Nästa');
    next.innerHTML = arrowSvg('right');

    prev.addEventListener('click', () => scroll(track, -1));
    next.addEventListener('click', () => scroll(track, 1));

    slider.appendChild(prev);
    slider.appendChild(next);
  }

  function scroll(track, direction) {
    const firstSlide = track.querySelector('.blog-slide');
    if (!firstSlide) return;
    const gap = parseFloat(getComputedStyle(track).columnGap || '0') || 15;
    const slideWidth = firstSlide.getBoundingClientRect().width + gap;
    track.scrollBy({ left: slideWidth * direction, behavior: 'smooth' });
  }

  function arrowSvg(dir) {
    const path =
      dir === 'left'
        ? '<path d="M9.5 1L1.5 8L9.5 15" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>'
        : '<path d="M2.5 1L10.5 8L2.5 15" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>';
    return `<svg viewBox="0 0 12 16" xmlns="http://www.w3.org/2000/svg">${path}</svg>`;
  }

  function initLightbox() {
    document.addEventListener('click', (e) => {
      const slide = e.target.closest('.blog-slide');
      if (!slide) return;

      const lightboxSrc = slide.dataset.lightboxSrc;
      const hasHref = slide.tagName === 'A' && slide.getAttribute('href');

      // Öppna lightbox om explicit data-lightbox-src ELLER om slide saknar href
      if (!lightboxSrc && hasHref) return;

      e.preventDefault();
      const img = slide.querySelector('img');
      const src = lightboxSrc || (img && img.src);
      if (!src) return;

      openLightbox(src, (img && img.alt) || '');
    });
  }

  function openLightbox(src, alt) {
    const lb = document.createElement('div');
    lb.className = 'blog-lightbox';
    lb.innerHTML =
      '<button class="blog-lightbox__close" aria-label="Stäng">✕</button>' +
      '<img src="' + src + '" alt="' + alt.replace(/"/g, '&quot;') + '">';

    document.body.appendChild(lb);
    requestAnimationFrame(() => lb.classList.add('blog-lightbox--open'));

    function close() {
      lb.remove();
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
    }

    lb.addEventListener('click', close);
    document.addEventListener('keydown', onKey);
  }

  function init() {
    document.querySelectorAll('.blog-slider').forEach(initSlider);
    initLightbox();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
